/**
 * useAttributionCapture — stash first-touch acquisition on app load, then send it
 * once the user is authenticated. Call once, high in the tree (RootNavigator).
 */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../store';
import { captureFirstTouch, sendAttributionIfNeeded } from './attribution';

export function useAttributionCapture(): void {
  const authorized = useSelector((s: RootState) => s.session.authorized);

  // Capture as early as possible (referrer/UTM are freshest at first load).
  useEffect(() => { captureFirstTouch(); }, []);

  // Send once we know who they are.
  useEffect(() => { if (authorized) sendAttributionIfNeeded(); }, [authorized]);
}
